import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { AppModal } from '../AppModal';
import './OnyxConfirmModal.css';

/**
 * Confirm / danger confirm modal built on AppModal.
 */
export function OnyxConfirmModal({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  confirming = false,
}) {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="sm"
      data-testid="onyx-confirm-modal"
      actions={(
        <>
          <Button variant="outlined" onClick={onClose} disabled={confirming}>
            {cancelLabel}
          </Button>
          <Button
            variant={danger ? 'contained' : 'onyxPrimary'}
            color={danger ? 'error' : 'primary'}
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirmLabel}
          </Button>
        </>
      )}
    >
      {children}
    </AppModal>
  );
}

OnyxConfirmModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.node,
  children: PropTypes.node,
  confirmLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  danger: PropTypes.bool,
  confirming: PropTypes.bool,
};
